'use strict';

import React from 'react';
import {BrowserRouter, Route, NavLink, Link, Switch} from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import * as Connections from "../utils/Connections";
import ProduceStore from "../stores/ProduceStore";
import * as Cookies from "../utils/Cookies";
import $ from 'jquery';
import Farmers from '../pages/HopePageBabies/Farmers';
import Profile from '../pages/HopePageBabies/Profile';
import Bills from '../pages/HopePageBabies/Bills';
import ActiveOrders from '../pages/HopePageBabies/ActiveOrders';
import ReadyForDeliveryOrders from '../pages/HopePageBabies/ReadyForDeliveryOrders';
import CompletedOrders from '../pages/HopePageBabies/CompletedOrders';
import Available from '../pages/HopePageBabies/Available';
import UpdateSettings from '../pages/HopePageBabies/UpdateSettings';
import Home from '../pages/HopePageBabies/Home'
import DatePicker from 'react-datepicker';
import moment from 'moment';

const styles = {
    modal: {
        borderRadius: '0'
    },
    marginSide: {
        marginLeft: '1em'
    },
    date: {
        marginTop: "0px !important"
    }
};
let footer;
export default class Header extends React.Component {

    constructor(props) {
        super(props);

        var orderList = [];
        var total = 0;
        // alert(Cookies.checkCookie("orderList").length)

        Cookies.checkCookie("orderList").length > 0 ? (
            orderList = JSON.parse(Cookies.checkCookie("orderList")),
                orderList.map((item) => {
                    total += item.price * item.quantity;
                })
        ) : (orderList = []);

        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handlePriceChange = this.handlePriceChange.bind(this);
        this.handleProduceNameChange = this.handleProduceNameChange.bind(this);
        this.updateProduceList = this.updateProduceList.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handlePreferredFarmers = this.handlePreferredFarmers.bind(this);
        this.editItemList = this.editItemList.bind(this);
        this.saveEditItemList = this.saveEditItemList.bind(this);
        this.removeItemList = this.removeItemList.bind(this);
        this.submitOrders = this.submitOrders.bind(this);
        this.handlePackagingChange = this.handlePackagingChange.bind(this);
        this.handleSetPackagingOptions = this.handleSetPackagingOptions.bind(this);
        this.handleOpenExternal = this.handleOpenExternal.bind(this);
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.state = {
            modal: false,
            editMode: false,
            editIndex: -1,
            produceList: [],
            count: 0,
            produceName: "",
            quantity: "",
            description: "",
            price: "",
            orderList: orderList || [],
            startDate: moment(),
            time: "12:00 AM",
            totalAccumulate: total,
            wantsPreferred: false,
            selectedIndex: 0,
            open: false,
            show: false,
            lock: false,
            mycart: "",
            packaging: [],
            selectedOption: "",
            imageUrl: "",
            toggleOpen:true
        };

    }

    componentWillMount() {
        this.setState({
            allFarmers: ProduceStore.getAll(),
            open: false,
            show: false,
            lock: false

        });
        ProduceStore.on("change", this.updateProduceList);
        Connections.getProduceList();
    }

    componentDidMount() {
        // alert(document.getElementById("produce-selector"))//=2;
    }

    handleSetPackagingOptions(name) {
        let selectedProduce = name;
        let self = this;
        for (var i = 0; i < this.state.produceList.length; i++) {
            if (this.state.produceList[i].name.trim() == selectedProduce) {
                let op = this.state.produceList[i].packaging.split(",");
                self.setState({
                    packaging: op,
                    selectedOption: op[0]
                }, function () {
                });
                break;

            }
        }
    }

    handleOpen(data) {
        this.setState({open: true});
    };

    handleOpenExternal(produceName, producePrice, imageUrl, packaging) {
        this.setState({
            produceName: produceName,
            price: producePrice,
            imageUrl: imageUrl,
            open: true,
            selectedOption: packaging
        });
    };

    handleClose() {
        this.setState({open: false, editMode: false, selectedIndex: 0}, function () {
            // this.handleSetPackagingOptions(this.state.produceList[this.state.selectedIndex].name.trim());
        });
    };

    handleCheckoutOpen() {
        this.setState({openCheckout: !this.state.openCheckout});
    };

    handleCheckoutClose() {
        this.setState({openCheckout: !this.state.openCheckout});
    };


    updateProduceList() {
        let self = this
        this.setState({
            produceList: ProduceStore.getAll()  ,
            selectedOption: this.state.packaging.length > 0 ? this.state.packaging[0] : ""
        }, function () {
            // console.log(self.state.produceList)
            // this.handleSetPackagingOptions(this.state.produceList[this.state.selectedIndex].name.trim());
            // this.setState({selectIndex: document.getElementById("produce-selector").selectedIndex});
        });
    }

    getProduce(name) {
        return this.state.produceList.find((item)=>item.name.trim()==name.trim());

    }

    handleAddToCart() {
        var self = this;

        var produceItem = self.getProduce(self.state.produceName);
        if (self.state.produceName == "") {

        }
        if (produceItem && !this.state.wantsPreferred) {
            // var due_date = document.getElementsByClassName("date uk-input")[0].value + " " + self.state.time;
            // console.log(document.getElementsByClassName("date uk-input")[0].value)
            var object = {
                id: Date.now(),
                produce_type: produceItem.id,
                produce_name: produceItem.name,
                preferred: 0,
                quantity: self.state.quantity,
                description: self.state.description,
                price: self.state.price,
                // due_date: due_date,
                // selectIndex: document.getElementById("produce-selector").selectedIndex,
                packaging: this.state.selectedOption,
                imageUrl: this.state.imageUrl
            };
            var l = this.state.orderList;
            var t = this.state.totalAccumulate;
            l[l.length] = object;
            t += self.state.quantity * self.state.price;
            this.setState({
                orderList: l,
                count: this.state.count + 1,
                totalAccumulate: t,
                quantity: "",
                description: "",
                price: "",
                startDate: moment(),
                time: "12:00 AM",
                wantsPreferred: false,
                packaging: []
            });
            console.log(object)
            self.handleClose();
        } else if (produceItem && this.state.wantsPreferred) {
            var sendData = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded'
                }),
                body: $.param({
                    type: "checkAvailability",
                    produce: produceItem.id,
                    token: Cookies.checkCookie("accessToken")
                })
            };

            fetch(Connections.getLinkLocation(), sendData)
                .then((resp) => resp.json()) // Transform the data into json
                .then(function (data) {
                    if (data.success == 1) {
                        if (data.quantity < self.state.quantity) {
                            alert("Your preferred farmers don't have " + self.state.quantity + " " + produceItem.name + " in stock.")
                        } else {
                            console.log(self.state);
                            var due_date = $(".date.uk-input").val() + " " + self.state.time;
                            var object = {
                                id: Date.now(),
                                produce_type: produceItem.id,
                                produce_name: produceItem.name,
                                preferred: 1,
                                quantity: self.state.quantity,
                                description: self.state.description,
                                price: self.state.price,
                                due_date: due_date,
                                selectIndex: document.getElementById("produce-selector").selectedIndex, //Used for editting, don't send to backend
                                packaging: self.state.selectedOption
                            };
                            var l = self.state.orderList;
                            var t = self.state.totalAccumulate;
                            l[l.length] = object;
                            t += self.state.quantity * self.state.price;
                            self.setState({
                                orderList: l,
                                count: self.state.count + 1,
                                totalAccumulate: t
                            });
                            self.handleClose();
                        }
                    } else {
                        alert(data.message);
                    }
                    // Create and append the li's to the ul
                });
        }
        Cookies.setCookie("orderList", JSON.stringify(this.state.orderList));
        // console.log(l);

    }

    handleChangeDate(e) {
        this.setState({startDate: e})
    }

    handleQuantityChange(e) {
        this.setState({
            quantity: e
        });
    }

    handleProduceNameChange(e) {
        console.log(e);
        let strUser = e;
        let get = strUser.split("(");
        let item = get[1].split(")");
        let kl = item[0].split(" ");
        this.setState({
            price: kl[0],
            produceName: get[0].trim(),
            selectedOption: this.state.packaging.length > 0 ? this.state.packaging[0] : ""
        });
        this.handleSetPackagingOptions(get[0].trim());
    }

    handlePackagingChange(e) {
        this.setState({
            selectedOption: e
        });
    }

    handleDescriptionChange(e) {
        this.setState({
            description: e
        });
    }

    handlePreferredFarmers() {
        var preferred = this.state.wantsPreferred;
        preferred ? (preferred = false) : (preferred = true);
        this.setState({
            wantsPreferred: preferred
        });
    }

    handlePriceChange(e) {
        this.setState({
            price: e
        });
    }

    handleTime(e) {
        this.setState({time: e});
        console.log(this.state);
    }

    removeItemList(index) {
        var list = this.state.orderList;
        var item = list[index];
        var t = this.state.totalAccumulate;

        t -= item.quantity * item.price;
        list.splice(index, 1);
        this.setState({orderList: list, totalAccumulate: t})
        Cookies.setCookie("orderList", JSON.stringify(this.state.orderList))

    }

    editItemList(index) {
        var item = this.state.orderList[index];
        /*var object = {
            id: Date.now(),
            type: "placeOrder",
            produce_type: produceItem.id,
            produce_name: produceItem.name,
            token: Cookies.checkCookie("accessToken"),
            preferred: 0,
            quantity: self.state.quantity,
            description: self.state.description,
            price: self.state.price,
            due_date: due_date
        };*/
        // var time = item.due_date.split(" ")[1] + " " + item.due_date.split(" ")[2];
        var pref;
        // var date = moment(item.due_date.split(" ")[0]);

        item.preferred == 0 ? (pref = false) : (pref = true);
        this.setState({
            editMode: true,
            editIndex: index,
            produceId: item.produce_type,
            produceName: item.produce_name,
            quantity: item.quantity,
            description: item.description,
            price: item.price,
            // startDate: date,
            date: "",
            open: true,
            // time: time,
            // selectedIndex: item.selectIndex,
            wantsPreferred: pref,
            imageUrl: item.imageUrl
        });
        this.handleSetPackagingOptions(item.produce_name);
    }

    saveEditItemList() {
        let index=this.state.editIndex
        var list = this.state.orderList;
        var item = list[index];
        var self = this;
        var t = this.state.totalAccumulate;
        var produceItem = self.getProduce(self.state.produceName);
        var due_date = $(".date.uk-input").val() + " " + self.state.time;

        t -= item.quantity * item.price;
        //var object = {
        item.produce_type = produceItem.id;
        item.produce_name = produceItem.name;
        item.token = Cookies.checkCookie("accessToken");
        item.preferred = 0;
        item.quantity = self.state.quantity;
        item.description = self.state.description;
        item.price = self.state.price;
        item.due_date = due_date;

        list[index] = item;

        t += item.quantity * item.price;
        this.setState({orderList: list, totalAccumulate: t, open: false});
        Cookies.setCookie("orderList", JSON.stringify(this.state.orderList))

    }

    submitOrders() {
        var self = this;
        let toSendOrders = [];
        this.state.orderList.forEach(function (order) {
            order["due_date"] = self.state.startDate + " " + self.state.time
            toSendOrders.push(order)
        })
        var ordersSend = JSON.stringify(toSendOrders);
        var sendData = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            body: $.param({
                type: "placeOrder",
                token: Cookies.checkCookie("accessToken"),
                orders: ordersSend
            })
        };
        fetch(Connections.getLinkLocation(), sendData)
            .then((resp) => resp.json()) // Transform the data into json
            .then(function (data) {

                if (data.success == 1) {
                    self.setState({
                        orderList: [],
                        count: 0,
                        totalAccumulate: 0,
                        openCheckout: false
                    });
                    self.handleCheckoutClose();
                    Cookies.setCookie("orderList", JSON.stringify(self.state.orderList));
                    alert("Orders submitted");
                } else {
                    alert("There was an error with placing your order please try again later");
                }
            });
    }

    cartslidertoggle() {


        if (this.state.open === false) {

        }

    }

    toggle(){
        const {toggleOpen}=this.state
        if(!$('body').hasClass('layout-fullwidth')) {
            $('body').addClass('layout-fullwidth');
        } else {
            $('body').removeClass('layout-fullwidth');
            $('body').removeClass('layout-default'); // also remove default behaviour if set
        }
        this.setState({toggleOpen:!toggleOpen})
        if($(window).innerWidth() < 1025) {
            if(!$('body').hasClass('offcanvas-active')) {
                $('body').addClass('offcanvas-active');
            } else {
                $('body').removeClass('offcanvas-active');
            }
        }

    }

    render() {
        var selectTimes = [
            "12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM", "3:00 AM", "3:30 AM", "4:00 AM", "4:30 AM", "5:00 AM", "5:30 AM", "6:00 AM", "6:30 AM", "7:00 AM", "7:30 AM", "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
            "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM", "9:00 PM", "9:30 PM", "10:00 PM", "10:30 PM", "11:00 PM", "11:30 PM"
        ];
        var actions;
        var ModalTitle;
        {
            this.state.editMode ? (
                actions = [
                    <button onClick={this.handleClose} className="uk-button uk-button-default "
                            type="button">Cancel</button>,
                    <button style={styles.marginSide} className="uk-button uk-button-primary" type="button"
                            onClick={() => this.saveEditItemList()}>Save Edit</button>
                ],
                    ModalTitle = "Edit an order") : (
                actions = [
                    <button onClick={this.handleClose} className="uk-button uk-button-default "
                            type="button">Cancel</button>,
                    <button style={styles.marginSide} className="uk-button uk-button-primary" type="button"
                            onClick={()=>this.handleAddToCart()}>Add to Cart</button>
                ],
                    ModalTitle = "Make an order")
        }
        const checkoutActions = [
            <button onClick={() => this.handleCheckoutClose()} className="uk-button uk-button-default "
                    type="button">Cancel</button>,
            <button style={styles.marginSide} className="uk-button uk-button-primary" type="button"
                    onClick={this.submitOrders}>Submit Orders</button>,
        ];
        var self = this;


        return (
            <div id="wrapper">
                <nav className="navbar navbar-default navbar-fixed-top">
                    <div className="brand">
                        <Link to="/home"><img style={{height: "25px"}}
                                              src="https://client.khula.co.za//images/agric_logo.svg" alt="KHULA"
                                              className="img-responsive logo"/></Link>
                    </div>
                    <div className="container-fluid">
                        <div className="navbar-btn">
                            <button onClick={()=>this.toggle()} type="button" className="btn-toggler">
                                <i className={`lnr ${this.state.toggleOpen?"lnr-arrow-left-circle":"lnr-arrow-right-circle"}`}></i></button>
                        </div>
                        <div id="navbar-menu">
                            <ul className="nav navbar-nav navbar-right">
                                <li className="dropdown">
                                    <a href="#" onClick={this.handleCheckoutOpen.bind(this)} className="icon-menu">
                                        <i className="lnr lnr-cart"></i>
                                        <span className="badge bg-info">{this.state.orderList.length}</span>
                                    </a>
                                </li>
                                <li className="dropdown">
                                    <a onClick={this.handleOpen} className=""><i className="lnr lnr-file-add"></i>
                                        <span>Make An Order</span></a>
                                </li>
                                <li className="dropdown">
                                    <a href="#" className="dropdown-toggle" data-toggle="dropdown"><img
                                        src="https://khula.co.za//images/user.png" className="img-circle"
                                        alt="Avatar"/> <span>{Cookies.checkCookie('profileName')}</span></a>
                                    <ul className="dropdown-menu">
                                        <li><a href="#"><i className="lnr lnr-user"></i> <span>My Profile</span></a>
                                        </li>
                                        <li><a href="#"><i className="lnr lnr-cog"></i> <span>Settings</span></a></li>
                                        <li><Link to="/login"><i className="lnr lnr-exit"></i>
                                            <span>Logout</span></Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>


                <div className={this.state.openCheckout === true ? "cart-slider" : "cart-slider-inactive"}>
                    <div className="cart-heading">

                        <h3><img src="https://client.khula.co.za/images/goods.png"/> My Cart</h3>
                    </div>

                    {/*actions={checkoutActions}*/}
                    {/*open={this.state.openCheckout}*/}
                    {/*onRequestClose={() => this.handleCheckoutClose()}*/}
                    {/*autoScrollBodyContent={true}>*/}
                    {/*{this.renderList}*/}

                    <div className="cart-body">

                        {this.state.orderList.map((item, i) =>


                            <div className="checkout-product">
                                <div className="checkout-product-image">
                                    <img src={item.imageUrl}/>
                                </div>
                                <div className="checkout-product-content">
                                    <h5>{item.produce_name}</h5>
                                    <p>P:{item.price} | Q:{item.quantity}</p>
                                </div>
                                <div className="editdelete">
                                    <p onClick={() => self.editItemList(i)}>Edit </p>
                                    <p onClick={() => self.removeItemList(i)}>Delete</p>
                                </div>
                            </div>
                        )}


                    </div>


                    <div className="checkoutbutton">

                        <div className="timeanddate">

                            <div style={{marginTop: "0px", cursor: "pointer"}} className="cartdate">
                                Date
                                <div className="uk-inline">
                                    <DatePicker className="date uk-input"
                                                style={{cursor: "pointer"}}
                                                selected={this.state.startDate}
                                                onChange={this.handleChangeDate.bind(this)}
                                    />
                                </div>
                            </div>

                            <div className="carttime">
                                Time
                                <select className="uk-select uk-margin" id="packaging-selector"
                                        onChange={(e) => this.handleTime(e.target.value)}>
                                    {
                                        selectTimes.map((packaging, i) => {
                                            return <option key={i + "time"}>{packaging}</option>
                                        })
                                    }
                                </select>
                            </div>


                        </div>


                        <button onClick={this.submitOrders}>CHECKOUT:  R {this.state.totalAccumulate}</button>
                    </div>


                </div>

                {/*<Dialog*/}
                {/*title={<h3 className="uk-modal-title">Checkout</h3>}*/}
                {/*actions={checkoutActions}*/}
                {/*modal={false}*/}
                {/*open={this.state.openCheckout}*/}
                {/*onRequestClose={() => this.handleCheckoutClose()}*/}
                {/*autoScrollBodyContent={true}>*/}
                {/*{this.renderList}*/}

                {/*<table className="checkout-table">*/}
                {/*<thead>*/}
                {/*<tr>*/}
                {/*<th className="checkout-heading">#</th>*/}
                {/*<th className="checkout-heading">Produce Name</th>*/}
                {/*<th className="checkout-heading">Description</th>*/}
                {/*<th className="checkout-heading">Due Date</th>*/}
                {/*<th className="checkout-heading">Quantity</th>*/}
                {/*<th className="checkout-heading">Packaging</th>*/}
                {/*<th className="checkout-heading">Price/KG</th>*/}
                {/*<th className="checkout-heading" style={{border: "none"}}>TOTAL</th>*/}
                {/*<th className="checkout-heading" style={{border: "none"}}></th>*/}
                {/*</tr>*/}
                {/*</thead>*/}

                {/*<tbody>*/}
                {/*{*/}
                {/*this.state.orderList.map((item, i) => {*/}
                {/*var clas;*/}
                {/*i % 2 == 1 ? (clas = "even") : (clas = "");*/}
                {/*return (*/}
                {/*<tr key={i} className={"checkout-item-row " + clas} id={item.id}>*/}
                {/*<th scope="row">{i + 1}</th>*/}
                {/*<td>{item.produce_name}</td>*/}
                {/*<td>{item.description}</td>*/}
                {/*<td>{item.due_date}</td>*/}
                {/*<td>{item.quantity}</td>*/}
                {/*<td>{item.packaging}</td>*/}
                {/*<td>R {item.price}</td>*/}
                {/*<td>R {item.price * item.quantity}</td>*/}
                {/*<td><i className="checkout-item-action lnr lnr-cross"*/}
                {/*onClick={() => self.removeItemList(i)}></i><i*/}
                {/*className="checkout-item-action lnr lnr-pencil"*/}
                {/*onClick={() => self.editItemList(i)}></i></td>*/}
                {/*</tr>*/}
                {/*)*/}
                {/*})}*/}
                {/*</tbody>*/}
                // {/*/!*<tfoot>*!/*/}
                {/*/!*<tr>*!/*/}
                {/*/!*<th></th>*!/*/}
                {/*/!*<th></th>*!/*/}
                {/*/!*<th></th>*!/*/}
                {/*/!*<th></th>*!/*/}
                {/*/!*<th></th>*!/*/}
                {/*/!*<th style={{fontWeight: "bold"}}>TOTAL</th>*!/*/}
                {/*/!*<th className="checkout-heading">R {this.state.totalAccumulate}</th>*!/*/}
                {/*/!*<th style={{border: "none"}}></th>*!/*/}
                {/*/!*</tr>*!/*/}
                {/*/!*</tfoot>*!/*/}
                {/*/!*</table>*!/*/}
                {/**/}
                {/**/}
                {/*</Dialog>*/}


                <Dialog
                    title={<h3 className="uk-modal-title">{ModalTitle}</h3>}
                    // actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={true}>


                    <form className="orderform" style={{marginTop: '10px'}}>

                        <div className="orderheader">
                            <h4><img src={this.state.imageUrl} width="20%"/> {this.state.produceName}</h4>
                        </div>

                        {/*<div className="uk-margin">*/}
                        {/*Produce Name*/}
                        {/*<select className="uk-select" id="produce-selector"*/}
                        {/*onChange={(e) => this.handleProduceNameChange(e.target.value)}>*/}
                        {/*{*/}
                        {/*this.state.produceList && this.state.produceList.map((produceItem, i) => {*/}
                        {/*if (this.state.produceName == "" && i == 0) {*/}
                        {/*this.handleProduceNameChange(produceItem.name + " (" + produceItem.price + ")/KG");*/}
                        {/*}*/}
                        {/*return <option*/}
                        {/*key={produceItem.id}>{produceItem.name} ({produceItem.price})/KG</option>*/}
                        {/*})*/}
                        {/*}*/}
                        {/*</select>*/}
                        {/*</div>*/}
                        {/*<div>*/}
                        {/*Packaging options*/}
                        {/*<select className="uk-select" id="packaging-selector"*/}
                        {/*onChange={(e) => this.handlePackagingChange(e.target.value)}>*/}
                        {/*{*/}
                        {/*this.state.packaging.map((packaging, i) => {*/}
                        {/*return <option key={i + "pack"}>{packaging}</option>*/}
                        {/*})*/}
                        {/*}*/}
                        {/*</select>*/}
                        {/*</div>*/}
                        <div className="orderquantity">
                            Quantity
                            <input className="uk-input" type="text" placeholder="Quantity (in kg)"
                                   value={this.state.quantity}
                                   onChange={(e) => this.handleQuantityChange(e.target.value)}/>
                        </div>

                        <div className="orderprice">
                            BID Price
                            <input className="uk-input" type="text" placeholder="BID Price (ZAR)"
                                   value={this.state.price}
                                   onChange={(e) => this.handlePriceChange(e.target.value)}/>
                        </div>

                        <div className="orderdescription">
                            Description
                            <textarea className="uk-textarea" rows="5"
                                      placeholder="Description (any additional notes)" value={this.state.description}
                                      onChange={(e) => this.handleDescriptionChange(e.target.value)}>

                              </textarea>
                        </div>

                        <div className="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                                <span><input className="" onChange={this.handlePreferredFarmers}
                                             checked={this.state.wantsPreferred} type="checkbox"/> Use preferred farmers - see preferred farmers list</span>
                        </div>

                        {/*<div className="row">*/}
                        {/*<div className="col-lg-6">*/}
                        {/*<label>Due Date</label>*/}
                        {/*<div style={{marginTop: "0px", cursor: "pointer"}} className="uk-margin">*/}
                        {/*<div className="uk-inline">*/}
                        {/*<DatePicker className="date uk-input"*/}
                        {/*style={{cursor: "pointer"}}*/}
                        {/*selected={this.state.startDate}*/}
                        {/*onChange={this.handleChangeDate.bind(this)}*/}
                        {/*/>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*<div>*/}
                        {/*Time*/}
                        {/*<select className="uk-select uk-margin" id="packaging-selector"*/}
                        {/*onChange={(e) => this.handleTime(e.target.value)}>*/}
                        {/*{*/}
                        {/*selectTimes.map((packaging, i) => {*/}
                        {/*return <option key={i + "time"}>{packaging}</option>*/}
                        {/*})*/}
                        {/*}*/}
                        {/*</select>*/}
                        {/*</div>*/}

                        {/*</div>*/}
                        {/*</div>*/}


                    </form>
                    {!this.state.editMode&&<button onClick={()=>this.handleAddToCart()}>Add to cart</button>}
                    {this.state.editMode&&<button onClick={this.saveEditItemList.bind(this)}>Update Order</button>}

                </Dialog>


                <div id="sidebar-nav" className="sidebar">
                    <div className="sidebar-scroll">
                        <nav>
                            <ul className="nav">
                                <li><NavLink to="/home" activeClassName="active"><i className="lnr lnr-user"></i>
                                    <span>Home</span></NavLink></li>
                                {/*<li><NavLink to="/home/profile" activeClassName="active"><i*/}
                                {/*className="lnr lnr-user"></i> <span>Profile</span></NavLink></li>*/}

                                <li>
                                    <a href="#subPages2" data-toggle="collapse" className="collapsed"><i
                                        className="lnr lnr-users"></i> <span>MarketPlace</span> <i
                                        className="icon-submenu lnr lnr-chevron-left"></i></a>
                                    <div id="subPages2" className="collapse ">
                                        <ul className="nav">
                                            <li><NavLink to="/home/available" activeClassName="active">Available
                                                Produce</NavLink></li>
                                            <li><NavLink to="/home/farmers" activeClassName="active" className="">Favorite
                                                Farmers</NavLink></li>
                                            <li><NavLink to="/home/available" activeClassName="active" className="">Offtake
                                                Contracts
                                            </NavLink></li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <a href="#subPages" data-toggle="collapse" className="collapsed"><i
                                        className="lnr lnr-list"></i> <span>Orders</span> <i
                                        className="icon-submenu lnr lnr-chevron-left"></i></a>
                                    <div id="subPages" className="collapse ">
                                        <ul className="nav">
                                            <li><NavLink to="/home/active-orders" activeClassName="active" className="">Orders
                                                being Harvested</NavLink></li>
                                            <li><NavLink to="/home/ready-for-delivery" activeClassName="active"
                                                         className="">On its way</NavLink></li>
                                            <li><NavLink to="/home/complete-orders" activeClassName="active"
                                                         className="">Delivered Orders</NavLink></li>
                                        </ul>
                                    </div>
                                </li>
                                <li><NavLink to="/home/billing" activeClassName="active" className=""><i
                                    className="lnr lnr-file-empty"></i> <span>Billing</span></NavLink></li>
                                <li><NavLink to="/home/settings" activeClassName="active" className=""><i
                                    className="lnr lnr-cog"></i> <span>Profile</span></NavLink></li>
                                <li><NavLink to="/login" activeClassName="active" className=""><i
                                    className="lnr lnr-exit"></i> <span>Logout</span></NavLink></li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="main">
                    <Switch>
                        <Route path={this.props.match.path + '/profile'} component={Profile} exact/>
                        <Route path={this.props.match.path + '/farmers'} component={Farmers} exact/>
                        <Route path={this.props.match.path + '/billing'} render={(routeProps) => (
                            <Bills self={() => this}/>
                        )}
                               exact/>
                        <Route path={this.props.match.path + '/active-orders'} component={ActiveOrders} exact/>
                        <Route path={this.props.match.path + '/ready-for-delivery'} component={ReadyForDeliveryOrders}
                               exact/>
                        {/*component={Available}*/}
                        <Route path={this.props.match.path + '/available'} render={(routeProps) => (
                            <Available self={() => this}/>
                        )}
                               exact/>
                        <Route path={this.props.match.path + '/complete-orders'} component={CompletedOrders} exact/>
                        <Route path={this.props.match.path + '/settings'} component={UpdateSettings} exact/>
                        <Route exect path={'/home'} render={(routeProps) => (
                                <Home self={() => this}/>
                            )}/>
                    </Switch>
                </div>


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header.js